<script setup lang="ts">
export interface CiErrorProps {
  message: string;
}
const props = withDefaults(defineProps<CiErrorProps>(), {});

const { $gettext } = useGettext();
</script>

<template>
  <div>
    <div class="row">
      <div class="col-4 offset-4 col-md-4 offset-md-4 col-lg-2 offset-lg-5">
        <CiAnimatedCross />
      </div>
    </div>
    <div class="row mt-6">
      <div class="col-12 text-center">
        <h3>
          <span>{{ $gettext('Uh oh.') }}</span>
        </h3>
        <div v-html="props.message" />
      </div>
    </div>
  </div>
</template>
